// Mock data for YuZu Recruitment Services

export const jobListings = [
  {
    id: 1,
    title: "General Manager",
    location: "Cape Town, Western Cape",
    type: "Permanent",
    description: "Leading fine dining establishment seeks experienced General Manager with proven track record in operational excellence and team leadership.",
    requirements: [
      "5+ years in hospitality management",
      "Strong operational and financial acumen",
      "Proven leadership in high-pressure environments",
      "Exceptional guest service standards"
    ],
    postedDate: "2025-01-10"
  },
  {
    id: 2,
    title: "Head Chef",
    location: "Johannesburg, Gauteng",
    type: "Permanent",
    description: "Premium restaurant group requires Head Chef with modern culinary expertise and team management skills.",
    requirements: [
      "Minimum 7 years culinary experience",
      "Leadership in high-volume kitchens",
      "Menu development and cost control",
      "Strong team building capabilities"
    ],
    postedDate: "2025-01-08"
  },
  {
    id: 3,
    title: "Floor Manager",
    location: "Durban, KwaZulu-Natal",
    type: "Permanent",
    description: "Established hospitality group seeks Floor Manager with exceptional service standards and operational discipline.",
    requirements: [
      "3+ years floor management experience",
      "Strong customer service orientation",
      "Team coordination and training skills",
      "Conflict resolution capabilities"
    ],
    postedDate: "2025-01-05"
  },
  {
    id: 4,
    title: "Restaurant Operations Manager",
    location: "Pretoria, Gauteng",
    type: "Permanent",
    description: "Multi-site restaurant operator requires Operations Manager to oversee daily operations and drive consistency.",
    requirements: [
      "Multi-site management experience",
      "Strong operational systems knowledge",
      "P&L accountability",
      "Change management expertise"
    ],
    postedDate: "2025-01-12"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Hidden Cost of High Turnover in Hospitality",
    excerpt: "Why replacing the same role every six months is costing more than you think, and how structured screening prevents it.",
    date: "2025-01-15",
    readTime: "5 min read",
    category: "Operational Insight"
  },
  {
    id: 2,
    title: "Strong CV. Weak Accountability.",
    excerpt: "Experience on paper doesn't guarantee operational stability. Understanding the difference between skills and reliability.",
    date: "2025-01-10",
    readTime: "4 min read",
    category: "Hiring Strategy"
  },
  {
    id: 3,
    title: "Why Behavioural Screening Matters More Than References",
    excerpt: "How pressure tolerance and team accountability predict long-term success better than traditional reference checks.",
    date: "2025-01-05",
    readTime: "6 min read",
    category: "Risk Management"
  },
  {
    id: 4,
    title: "The Founder-Led Advantage in Recruitment",
    excerpt: "Why direct founder involvement in every shortlist creates better hiring outcomes for hospitality operators.",
    date: "2024-12-28",
    readTime: "5 min read",
    category: "YuZu Method"
  }
];

export const caseStudies = [
  {
    id: 1,
    category: "Fine Dining Restaurant",
    location: "Cape Town",
    challenge: "Three GM replacements in 18 months. High turnover affecting service consistency and team morale.",
    solution: "Structured behavioural screening identified pressure tolerance gaps in previous hiring process. Implemented role-specific risk assessment.",
    outcome: "Placement stable for 12+ months. Service consistency restored. Team turnover reduced by 60%.",
    timeline: "18 months"
  },
  {
    id: 2,
    category: "Multi-Site Restaurant Group",
    location: "Johannesburg",
    challenge: "Volume recruitment approach delivering misaligned candidates. Operational disruption from poor cultural fit.",
    solution: "Controlled shortlist delivery with founder-level evaluation. Behavioural and reliability screening prioritised over CV volume.",
    outcome: "Alignment improved across all placements. Re-hiring cycle eliminated. Operational stability achieved.",
    timeline: "12 months"
  },
  {
    id: 3,
    category: "Premium Hotel Restaurant",
    location: "Durban",
    challenge: "Recurring behavioural issues with management hires. Inability to handle high-pressure service periods effectively.",
    solution: "Pressure tolerance assessment and team impact evaluation integrated into screening. Reference verification restructured.",
    outcome: "Management team stability established. Guest satisfaction scores improved. Conflict incidents reduced by 75%.",
    timeline: "9 months"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Why must Terms of Business be signed before sourcing?",
    answer: "Because structured engagement protects both parties and ensures serious intent. It establishes clear expectations and accountability from the outset."
  },
  {
    id: 2,
    question: "Why don't you send multiple CVs immediately?",
    answer: "Because alignment matters more than volume. We assess behavioural fit, reliability, and operational suitability before presentation. Quality over quantity ensures better placement outcomes."
  },
  {
    id: 3,
    question: "Do you operate outside hospitality?",
    answer: "No. Specialisation ensures screening depth. Our focus on hospitality allows us to understand operational pressure points, behavioural requirements, and stability factors specific to restaurants and hospitality groups."
  },
  {
    id: 4,
    question: "Is the service confidential?",
    answer: "Yes. Discretion is standard practice. All vacancy discussions, candidate information, and operational insights remain confidential."
  },
  {
    id: 5,
    question: "What is your fee structure?",
    answer: "YuZu Recruitment Services operates on both retained and success-based models, depending on the nature and urgency of the assignment. Engagement structure and fees are discussed during a confidential consultation."
  },
  {
    id: 6,
    question: "How long does the recruitment process take?",
    answer: "Timelines vary based on role complexity and market conditions. We prioritize alignment over speed. Structured screening takes time, but reduces long-term turnover risk."
  }
];
